import React from 'react';

import LoggedIn from './LoggedIn';
import Layout from '../../components/Layout';

async function action() {
  return {
    component: (
      <Layout>
        <LoggedIn />
      </Layout>
    ),
  };
}

export default action;
